import { defineComponent as _defineComponent } from 'vue'
import CreateEventDate from '@/pages/CreateEventProcessingPage/ui/CreateEventDate.vue'
import CreateEventTiers from '@/pages/CreateEventProcessingPage/ui/CreateEventTiers.vue'
import CreateEventBattles from '@/pages/CreateEventProcessingPage/ui/CreateEventBattles.vue'
import CreateEventTotal from '@/pages/CreateEventProcessingPage/ui/CreateEventTotal.vue'
import { eventApi, EventDB } from '@/enitites/event'
import { computed, getCurrentInstance, onMounted, provide, ref } from 'vue'
// @ts-expect-error Not a ts file
import store from '@/store'
import { useRoute, useRouter } from 'vue-router/composables'
import { CreateEventFormName } from '@/pages/CreateEventProcessingPage/model/types'
import CreateEventDisplayMode from '@/pages/CreateEventProcessingPage/ui/CreateEventDisplayMode.vue'
import CreateEventInfo from './CreateEventInfo.vue'

type CreateEventForm =
  | typeof CreateEventInfo
  | typeof CreateEventDate
  | typeof CreateEventTiers
  | typeof CreateEventBattles
  | typeof CreateEventTotal
  | typeof CreateEventDisplayMode


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventProcessingPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const isClickBtnNext = ref(true)

function updateIsClickBtnNext(value: boolean) {
  isClickBtnNext.value = value
}

provide('isClickBtnNext', {
  updateIsClickBtnNext,
})
const CreateEventForms: Record<CreateEventFormName, CreateEventForm> = {
  CreateEventInfo,
  CreateEventDate,
  CreateEventTiers,
  CreateEventBattles,
  CreateEventTotal,
  CreateEventDisplayMode,
}
const currentScreen = ref<CreateEventForm | undefined>()

function setCurrentScreen(value: CreateEventFormName) {
  currentScreen.value = CreateEventForms[value]
}

provide('currentScreen', {
  currentScreen,
  setCurrentScreen,
})
const eventData = ref<EventDB>()
const backStep = ref(false)
const loading = ref(true)
const error = ref(null)
const isNew = ref(true)

const getUserDB = computed(() => store.getters.getUserDB)
const instance = getCurrentInstance()

async function initEvent() {
  if (!getUserDB.value) {
    await router.push({ name: 'EventsPage' })
    return
  }

  const event = await eventApi.getEvent(Number(route.params.id))

  if (!event) {
    loading.value = false
    await router.push({ name: 'EventsPage' })
    return
  }
  eventData.value = event

  if (eventData.value.title) {
    isNew.value = false
    currentScreen.value = CreateEventTotal
    loading.value = false
  } else {
    await store.dispatch('setIsCreateEventFlow', true)
    currentScreen.value = CreateEventForms.CreateEventInfo
    loading.value = false
  }
}

async function updateEvent() {
  if (!eventData.value) return
  if (eventData.value.description) {
    eventData.value.description = instance?.proxy?.$sanitize(eventData.value.description)
  }
  await eventApi.updateEvent(eventData.value)
}

async function publishEvent() {
  if (!eventData.value) return
  await eventApi.publishEvent(eventData.value.id)
  await store.dispatch('showAlertToast', 'eventCreated')
  await store.dispatch('setShowEventInfoModal', true)
  await router.push({ name: 'Event', params: { id: String(eventData.value.id) } })
}

async function saveDraftEvent() {
  if (!eventData.value) return
  await eventApi.updateEvent(eventData.value)
  await store.dispatch('showAlertToast', 'eventCreated')
  await router.push({ name: 'Event', params: { id: String(eventData.value.id) } })
}

onMounted(() => {
  initEvent()
})

return { __sfc: true,router, route, isClickBtnNext, updateIsClickBtnNext, CreateEventForms, currentScreen, setCurrentScreen, eventData, backStep, loading, error, isNew, getUserDB, instance, initEvent, updateEvent, publishEvent, saveDraftEvent }
}

})